<script>
import { getLocations } from "@/api/locations";
import { getRecommendedControlStores } from "@/api/analytics";
import { getOtherCampaignControlSotres,setOtherCampaignControlSotres } from "@/api/campaigns";
import swal from "sweetalert";
export default {
  name: "controls-dialog",
  props: ["show", "formCampaign","campaignLocations"],
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      dialogDelete: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "related_control_stores.name"
        },
        { text: "Address", value: "related_control_stores.street" },
        { text: "City", value: "related_control_stores.city" },
        { text: "State", value: "related_control_stores.state" },
        { text: "Fit Ranking", value: "fit_score" }
      ],
      locations: [],
      loading: false,
      formData:[]
    };
  },  
  async mounted() {
    console.log("Controls Dialog");
    if (this.formCampaign.campaign==undefined){
      swal("Notice", "Campaign is required");
        return false
    }
    let current_campaign_control_stores = await getOtherCampaignControlSotres(this.formCampaign.campaign.id);
    this.formData = current_campaign_control_stores
    this.locations = current_campaign_control_stores.control_stores
    console.log("Campaign control stores:",current_campaign_control_stores,this.locations)
    if (this.locations.length==0){
      swal("Notice", "Control stores unavailable. You have selected too many stores for your campaign and have no available control stores. Try removing stores from your campaign.");
        return false
    }    
    this.selected = this.locations.filter(location => location.is_selected);
    
  },
  watch: {
    searchTrigger(q) {
      let componentEvent = this.$refs.dataTableComponent
      componentEvent.updateSearchField(q)      
    }    
  },
  computed: {
    visible() {
      return this.show;
    },
    searchTrigger() {
      return this.search;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async setRecommendedControlStores(){
      if (!this.formCampaign.selectedCampaign) {
        swal("Notice", "Campaign is required");
        return false
      }
      const payload = JSON.parse(
        JSON.stringify({
          campaign_id: this.formCampaign.campaign.id
        })
      );
      this.loading = true;
      const responses = await Promise.all([
        getRecommendedControlStores(payload),
      ]);
      let recommendedControlStores = responses[0];
      let recommended_pos_ids = recommendedControlStores.map(function (obj) {
        if (obj.is_relevant){
          return obj.pos_id;
        }        
      });
      recommended_pos_ids = recommended_pos_ids.filter(function( element ) {
        return element !== undefined;
      });
      console.log("Recommended control stores:",recommended_pos_ids)
      this.selected = this.locations.filter(location => recommended_pos_ids.includes(location.related_control_stores.pos_id));
      this.loading = false;      
      
    },
    async onSubmit() {
      try {
        // Saving form data
      if (!this.formCampaign.selectedCampaign) {
        swal("Notice", "Campaign is required");
        return false;
      }
      
      for(let i=0;i<this.formData.control_stores.length;i++){
        this.formData.control_stores[i]['is_selected']=false
        for(let j=0;j<this.selected.length;j++){
          if (this.selected[j]['id'] == this.formData.control_stores[i]['id']){
              this.formData.control_stores[i]['is_selected']=true
              break
          }   
        }
      }
      console.log("Form data",this.formData);
      let result = await setOtherCampaignControlSotres(this.formCampaign.campaign.id,this.formData);
      
      swal("Notice", "Campaign Control Stores Saved");
      
      } catch (error) {
        console.log("Error:",error)
      }
      
    },
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent scrollable width="80%">
    <v-card>
      <v-card-title class="headline justify-center">
        Control Stores
        <span
          style="float: right; position: absolute; right: 20px; color: #999; cursor:pointer"
          @click="close"
        >
          x</span
        >
      </v-card-title>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-card-text>
        We have automatically selected the below locations as your control group
        based upon where you told us you ran your campaign. If you'd like to
        change your control group - either by adding or removing locations - you
        may do so in the below table.
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text" id="btnGroupAddon2">
              <b-icon icon="search"></b-icon>
            </div>
          </div>
          <b-form-input v-model="search" placeholder="Search"></b-form-input>
        </div>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="locations"
          item-key="id"
          :sort-by="['name']"
          show-select
          class="elevation-1 mt-5 mb-10"
          :search="search"
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" @click="setRecommendedControlStores" depressed tile >
          Select Recommended Control Stores
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="close">
          Close
        </v-btn>
        <v-btn class="mr-4" @click="onSubmit" depressed color="primary">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
